import { useSyncUrl1 } from "./useSyncUrl";

export default useSyncUrl1;
